/**
 * SF-4799 — who created a company, as sf-api sends it on the admin company list and detail reads
 * (from the company "create" change-log entry). null = nothing recorded (companies from before
 * August 2025, and online sign-ups from before SF-4799). Missing = an sf-api that doesn't send it yet.
 */
export interface CompanyCreator {
  name: string | null;
  email: string | null;
  /** true when the company came from an online sign-up (set when the record was written). */
  self_serve: boolean;
  /** true when the creator's user account no longer exists. */
  deleted?: boolean;
}

interface CompanyCreatedByFields {
  created_by?: CompanyCreator | null;
  sales_channel?: string | null;
  /** ServeFirst Forms company (always an online sign-up). */
  forms_account?: boolean;
}

/** An online sign-up company: the self-serve sales channel, or a Forms company. */
const isSelfServeCompany = (c: CompanyCreatedByFields): boolean =>
  c.sales_channel === 'self_serve' || c.forms_account === true;

/** "Created by" text for the admin app list and detail page. */
export function createdByLabel(company?: CompanyCreatedByFields | null): string {
  if (!company || company.created_by === undefined) return '—';
  const creator = company.created_by;
  if (creator === null)
    return isSelfServeCompany(company) ? 'Self-serve (not recorded)' : 'Not recorded';
  if (creator.deleted) return creator.self_serve ? 'Self-serve: deleted user' : 'Deleted user';
  const who =
    creator.name && creator.email
      ? `${creator.name} (${creator.email})`
      : creator.name || creator.email || 'Unknown user';
  return creator.self_serve ? `Self-serve: ${who}` : who;
}
